import { AxiosResponse } from "axios";
import { useUserStore } from "@/stores/modules/user";
import {showToast} from 'vant'

interface NetError {
    code: string;
    i18n: string;
    field: string;
    message: string;
}

function getErrorMsg(error: NetError) {
    const whiteList = ["00000404"];

    if (!whiteList.includes(error.code)) {
        const field = error.field ? `${error.field}: ` : "";
        const code = error.code ? `${error.code}-` : "";
        const message = error.message ? `${error.message}` : "";
        console.error(field + code + message);
        return message;
    }
}

/**
 * @description: 校验网络请求状态码
 * @return void
 * @param response
 */
export const checkStatus = (response: AxiosResponse) => {
    let errorMessage: string = "";
    const { status } = response;
    if (status === 400) {
        const errors = response.data?.errors;
        if (errors !== null && errors?.length > 0) {
            const errorMsgs = errors.map(getErrorMsg);
            errorMessage = errorMsgs.join("<br />");
            // console.log(msg);
        } else {
            errorMessage = response.data?.message;
        }
    } else {
        switch (status) {
            case 401:
                const userStore = useUserStore();
                userStore.setToken("");
                const pathNameArray: string[] = window.location.pathname.split("/");
                if (pathNameArray[pathNameArray.length - 1] == "login") {
                    showToast({
                      message: response.data.message,
                      type: 'fail',
                      position: 'top'
                    });
                    return
                }
                break;
            case 403:
                errorMessage = "当前账号无权限访问！";
                break;
            case 404:
                errorMessage = "你所访问的资源不存在！";
                break;
            case 405:
                errorMessage = "请求方式错误！请您稍后重试";
                break;
            case 408:
                errorMessage = "请求超时！请您稍后重试";
                break;
            case 500:
                errorMessage = "服务异常！请联系系统管理员！";
                break;
            case 502:
                errorMessage = "网关错误！请联系系统管理员！";
                break;
            case 503:
                errorMessage = "服务不可用！请联系系统管理员！";
                break;
            case 504:
                errorMessage = "网关超时！请联系系统管理员！";
                break;
            default:
                errorMessage = "请求失败！";
        }
    }

    if (errorMessage) {
        showToast({
          message: errorMessage,
          type: 'fail',
          position: 'top'
        });
    }
};
